import { VideoButton } from '@geberit/gdds';
import { BUTTON_TYPES, Button } from 'components/Button/Button';

// styles
import styles from './videoPlayButton.module.scss';

// utils
import { useXy } from 'utils/hooks/use-xy';
import { useTranslationFunction } from 'utils/hooks/use-translations';

type VideoPlayButtonProps = {
  playVideo?: () => void;
  videoPlayButtonLabel?: string;
};

const VideoPlayButton = ({
  playVideo,
  videoPlayButtonLabel = 'Play Video',
}: Readonly<VideoPlayButtonProps>) => {
  const isXy = useXy();
  const translate = useTranslationFunction();

  return (
    <>
      {isXy ? (
        <VideoButton
          size="big"
          className={styles.videoPlayButton}
          onClick={playVideo}
          ariaLabel={translate('arialabel_video_play_button')}
        />
      ) : (
        <Button
          symbol=""
          type={BUTTON_TYPES.PLAIN}
          aria-label={translate('arialabel_video_play_button')}
          onClick={playVideo}
          className={`${styles.videoPlayButton} ${styles.nonGddsVideoPlayButton}`}
        />
      )}
    </>
  );
};

export default VideoPlayButton;
